const obj2Arr = obj => {
  let blocksFiltered
  if (Array.isArray(obj)) {
    blocksFiltered = obj
  } else {
    blocksFiltered = Object.values(obj)
  }
  return blocksFiltered
}

export default obj2Arr
